// extracted by mini-css-extract-plugin
export var subtitle = "styles-module--subtitle--6fc35";
export var title = "styles-module--title--2fc02";
export var wrapper = "styles-module--wrapper--1cb45";